var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"NewsPress"}},[_c('Hero',[_c('h1',[_vm._v(" "+_vm._s(_vm.$t('title'))+" ")])]),_c('SectionNews',{attrs:{"tag":_vm.activeTag}}),_c('SectionPress')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }